import { svc_editOptionItemSoldOut } from "@/services/menuitem";
import { svc_search, svc_addOne, svc_editOne, svc_deleteOne } from "@/services";
import { showServerResponse } from "@/utils/message";
import logger from "@/utils/logger";
const apiPrefix = "options/menu_items";

const Model = {
	namespace: "m_MenuItemOption",
	state: {
		soldOutOptionItemList: [],
	},
	reducers: {
		handleFetchSoldOutOptionItemList(state, { payload: { soldOutOptionItemList } }) {
			logger(`** MenuItem reducers response ${JSON.stringify(soldOutOptionItemList)}`, 5);
			return { ...state, soldOutOptionItemList };
		},
	},
	effects: {
		*addOption({ payload }, { call, put }) {
			delete payload.id;
			const response = yield call(svc_addOne, apiPrefix, payload);
			showServerResponse(response);
			return response;
		},
		*updateOption({ payload }, { call, put }) {
			if (payload && payload.id) {
				const response = yield call(svc_editOne, apiPrefix, payload, "id");
				showServerResponse(response);
				return response;
			}
		},
		*updateLinkedItem({ payload }, { call }) {
			return yield call(svc_editOne, "options/menu-item-links", payload, "id");
		},
		*deleteOption({ payload }, { call, put }) {
			payload = _.omit(payload, ["key"]);
			const response = yield call(svc_deleteOne, "options/delete", payload, "id");
			showServerResponse(response);
			return response;
		},
		*reorderOption({ payload }, { call, put }) {
			if (payload && payload.length > 0) {
				const response = yield call(svc_addOne, apiPrefix, payload, "reorder");
				showServerResponse(response);
				return response;
			}
		},
		*fetchSoldOutOptionItemList({ payload }, { call, put }) {
			// console.log("*********************** brandId: ", payload.brand)
			// console.log("*********************** outletId: ", payload.outlet)
			const queryObj = {
				...payload.brand && { brand: payload.brand },
				...payload.outlet && payload.outlet > 0 && { outlet: payload.outlet },
			}
			// console.log(queryObj)
			let soldOutOptionItemList = yield call(svc_search, `options/sold_out_list`, queryObj);
			_.forEach(soldOutOptionItemList, function (row) {
				row.key = row.id;
			});
			// console.log("*********************** soldOutOptionItemList: ", soldOutOptionItemList)
			yield put({
				type: "handleFetchSoldOutOptionItemList",
				payload: { soldOutOptionItemList },
			});
		},
		*updateOptionSoldOut({ payload }, { call, put }) {
			const { brandId, outletId, soldOut, formData } = payload;
			const response = yield call(svc_editOptionItemSoldOut, brandId, outletId, soldOut, formData);
			showServerResponse(response);
			return response;
		},
	},
	subscriptions: {},
};

export default Model;
